export default __webpack_public_path__ + "static/media/icon-team.07121b25.svg";